/*
 * LEO SPECIALTY COFFEE - reviews page enhancements.
 *
 * This script only adds presentation-layer behaviour on top of the
 * existing Judge.me "all reviews" widget (v2025). It never edits,
 * deletes, or duplicates review/reply text, never touches Judge.me's
 * own submission form, vote buttons, sort control, or product tabs,
 * and never sends data anywhere. It only:
 *   - moves a handful of existing review DOM nodes (not copies) into
 *     a "PICK UP REVIEWS" grid,
 *   - adds CSS classes / small toggle buttons for truncation and
 *     reply-collapse,
 *   - relabels the write-review link's visible text,
 *   - adds category filter chips + a "show more" control that only
 *     toggle CSS display on cards already present in the DOM.
 *
 * Update PRODUCT_CATEGORY_MAP below whenever a new product should be
 * grouped under 定期便 / コーヒー豆 / ドリップバッグ for the reviews
 * page filter. The key is the product handle (the part of the URL
 * after /products/).
 */
(function () {
  var PRODUCT_CATEGORY_MAP = {
    'leo特別定期会員送料無料-数量限定': '定期便',
    'leo特別定期会員送料無料-数量限定-ドリップバッグ': '定期便',
    'leo豆-粉単品300g': 'コーヒー豆',
    '単品選べる2種のドリップバッグタイプ': 'ドリップバッグ',
    'おためし10包入り単品選べる2種のドリップバッグタイプ': 'ドリップバッグ',
    '単品-水出しパック40g-10個セット': 'コーヒー豆',
    '単品豆-粉おためし3種セット80g-3タイプ': 'コーヒー豆'
  };
  var FILTER_CATEGORIES = ['すべて', '定期便', 'コーヒー豆', 'ドリップバッグ'];
  var PAGE_SIZE_DESKTOP = 9;
  var PAGE_SIZE_MOBILE = 6;
  var shownCount = PAGE_SIZE_DESKTOP;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function reviewCardsOf(body) {
    return Array.prototype.filter.call(body.children, function (c) {
      return c.classList && c.classList.contains('jdgm-rev');
    });
  }

  function categorize(card) {
    var link = card.querySelector('.jdgm-row-product a');
    if (!link) return 'その他';
    var handle = null;
    try {
      var u = new URL(link.href);
      var m = u.pathname.match(/\/products\/([^/?#]+)/);
      handle = m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      handle = null;
    }
    return (handle && PRODUCT_CATEGORY_MAP[handle]) || 'その他';
  }

  function addTruncation(card) {
    var bodyEl = card.querySelector('.jdgm-rev__body');
    if (!bodyEl || bodyEl.dataset.leoClamp) return;
    bodyEl.dataset.leoClamp = '1';
    bodyEl.classList.add('leo-rev-body--clamp');

    function maybeAddToggle() {
      if (bodyEl.dataset.leoToggleAdded) return;
      if (bodyEl.scrollHeight > bodyEl.clientHeight + 4) {
        bodyEl.dataset.leoToggleAdded = '1';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'leo-rev-more-toggle';
        btn.textContent = '続きを読む';
        btn.addEventListener('click', function () {
          var expanded = bodyEl.classList.toggle('leo-rev-body--expanded');
          btn.textContent = expanded ? '閉じる' : '続きを読む';
        });
        bodyEl.insertAdjacentElement('afterend', btn);
      }
    }

    // Web フォントの読み込みタイミングによって、最初の requestAnimationFrame
    // 時点ではまだ折り返し行数が確定しておらず overflow を見逃すことが
    // あったため、フォント読み込み完了後・少し遅延後にも再チェックし、
    // 後から overflow が判明した場合にも確実にトグルボタンが付くようにしている。
    window.requestAnimationFrame(maybeAddToggle);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(maybeAddToggle);
    }
    window.setTimeout(maybeAddToggle, 600);
  }

  function addReplyClamp(card) {
    // Shows the shop's reply preview (~3-4 lines) by default instead of
    // hiding it fully behind a click, with an expand toggle only when the
    // reply actually overflows the clamp. Mirrors addTruncation()'s pattern.
    var reply = card.querySelector('.jdgm-rev__reply');
    var content = reply ? reply.querySelector('.jdgm-rev__reply-content') : null;
    if (!content || content.dataset.leoReplyClamp) return;
    content.dataset.leoReplyClamp = '1';
    content.classList.add('leo-reply-content--clamp');

    function maybeAddToggle() {
      if (content.dataset.leoReplyToggleAdded) return;
      if (content.scrollHeight > content.clientHeight + 4) {
        content.dataset.leoReplyToggleAdded = '1';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'leo-rev-more-toggle';
        btn.textContent = '続きを読む';
        btn.addEventListener('click', function () {
          var expanded = content.classList.toggle('leo-reply-content--expanded');
          btn.textContent = expanded ? '閉じる' : '続きを読む';
        });
        content.insertAdjacentElement('afterend', btn);
      }
    }

    // addTruncation() と同様、フォント読み込み完了後・遅延後にも
    // 再チェックして overflow の見逃しを防ぐ。
    window.requestAnimationFrame(maybeAddToggle);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(maybeAddToggle);
    }
    window.setTimeout(maybeAddToggle, 600);
  }

  var WRITE_LINK_LABEL = 'LEOのレビューを書く';

  function relabelWriteLink() {
    // Judge.me sets/overwrites this link's label asynchronously as its own
    // widget hydrates, so a one-time "already relabelled" flag can get
    // silently reverted back to Judge.me's default text. Comparing against
    // the target text (instead of a dataset flag) makes this self-healing:
    // it only touches the DOM when the label actually differs, so it is
    // cheap to re-run on every init() pass and never fights itself.
    var writeLink = document.querySelector('.jdgm-write-rev-link');
    if (writeLink && writeLink.textContent.trim() !== WRITE_LINK_LABEL) {
      writeLink.textContent = WRITE_LINK_LABEL;
    }
  }

  var DATA_POLICY_PREFIX =
    '個人情報の取り扱いについて：ご投稿いただいたレビューに関して、必要な場合にのみご連絡させていただくことがあります。レビューを送信することで、Judge.meの';
  var DATA_POLICY_SEP = '、';
  var DATA_POLICY_SUFFIX = 'に同意したものとみなされます。';

  function relabelDataPolicyText() {
    // Judge.me's write-review form includes a data-usage disclaimer
    // paragraph with 3 links (terms / privacy / content-policy). This only
    // rewrites the surrounding Japanese wording to something more natural;
    // the 3 <a> elements (and their hrefs) are moved, not cloned, so their
    // targets and Judge.me's own consent-link behaviour are unchanged.
    // The form is re-created fresh each time it's opened, so this compares
    // the paragraph's current text against the target (rather than using a
    // one-time flag) and only touches the DOM when it still shows Judge.me's
    // original wording — the same self-healing approach as relabelWriteLink.
    var termsLinks = document.querySelectorAll('.jdgm-form-wrapper p a[href*="judge.me/terms"]');
    termsLinks.forEach(function (termsA) {
      var p = termsA.closest('p');
      if (!p) return;
      var anchors = p.querySelectorAll('a');
      if (anchors.length < 3) return;
      var firstNode = p.firstChild;
      var alreadyDone =
        firstNode && firstNode.nodeType === Node.TEXT_NODE && firstNode.textContent === DATA_POLICY_PREFIX;
      if (alreadyDone) return;
      var privacyA = anchors[1];
      var contentA = anchors[2];
      p.textContent = '';
      p.appendChild(document.createTextNode(DATA_POLICY_PREFIX));
      p.appendChild(termsA);
      p.appendChild(document.createTextNode(DATA_POLICY_SEP));
      p.appendChild(privacyA);
      p.appendChild(document.createTextNode(DATA_POLICY_SEP));
      p.appendChild(contentA);
      p.appendChild(document.createTextNode(DATA_POLICY_SUFFIX));
    });
  }

  var REVIEWER_NAME_LABEL = 'レビューに公開するお名前';
  var REVIEWER_NAME_FORMAT_LABEL_ORIGINAL = 'のように公開表示';
  // Judge.me ships 5 name-display presets, but "all_initials" (J.S. style)
  // was dropped from the visible list at the shop's request to keep the
  // choice simple: only 4 clearly-worded options remain. This order is
  // also the DOM/visual order the <option>s are sorted into below, so the
  // numbering in each label matches top-to-bottom reading order.
  var REVIEWER_NAME_OPTION_ORDER = ['', 'first_name_only', 'last_initial', 'anonymous'];
  var REVIEWER_NAME_OPTION_LABELS = {
    '': '①フルネーム',
    first_name_only: '②苗字のみ',
    last_initial: '③下のお名前のみ',
    anonymous: '④匿名'
  };
  var REVIEWER_NAME_OPTION_REMOVE = ['all_initials'];

  function relabelReviewerNameField() {
    // Judge.me's write-review form has an "お名前 (のように公開表示 John
    // Smith / John S. / John / J.S. / 匿名)" name-display-format control.
    // The English example names mean nothing to a Japanese customer, so
    // this rewrites the outer label and each remaining <option>'s visible
    // text to a plain-Japanese description of what each format does, and
    // removes the one preset ("all_initials") the shop doesn't want to
    // offer. The <select>'s id/name and every remaining <option>'s value
    // (i.e. what actually gets submitted) are completely untouched — this
    // only changes which values are selectable and how they're labelled/
    // ordered. Like the other relabel functions above, this re-runs on
    // every init() pass and compares current state against the target
    // rather than using a one-time flag, since the form is re-created
    // fresh each time it's opened.
    var labels = document.querySelectorAll('.jdgm-form__fieldset > label.jdgm-form__inline-label');
    labels.forEach(function (label) {
      if (label.textContent.trim() === 'お名前') {
        label.textContent = REVIEWER_NAME_LABEL;
      }
    });

    var formatLabel = document.querySelector('.jdgm-form__reviewer-name-format-container label.jdgm-form__inline-label');
    if (formatLabel && formatLabel.textContent.trim() === REVIEWER_NAME_FORMAT_LABEL_ORIGINAL) {
      formatLabel.textContent = '';
    }

    var selects = document.querySelectorAll('select[name="reviewer_name_format"]');
    selects.forEach(function (select) {
      REVIEWER_NAME_OPTION_REMOVE.forEach(function (val) {
        var opt = select.querySelector('option[value="' + val + '"]');
        if (opt) opt.remove();
      });

      REVIEWER_NAME_OPTION_ORDER.forEach(function (val, index) {
        var opt = select.querySelector('option[value="' + val + '"]');
        if (!opt) return;
        var target = REVIEWER_NAME_OPTION_LABELS[val];
        if (target !== undefined && opt.textContent !== target) {
          opt.textContent = target;
        }
        if (select.options[index] !== opt) {
          select.insertBefore(opt, select.options[index] || null);
        }
      });
    });
  }

  var SUBTAB_LABELS = { 'product-reviews': '商品レビュー' };

  function relabelSubtabs() {
    // Relabels the "製品レビュー (N)" sub-tab to "商品レビュー (N)" without
    // touching the live review count Judge.me renders inside
    // .jdgm-subtab__count. The tab's actual markup is a leading text node
    // ("製品レビュー ("), the count element, then a trailing ")" text node —
    // only the leading text node is swapped; the count and trailing ")"
    // are left completely untouched.
    var LEADING_TEXT = ' (';
    Object.keys(SUBTAB_LABELS).forEach(function (tabName) {
      var tab = document.querySelector('.jdgm-subtab__name[data-tabname="' + tabName + '"]');
      if (!tab) return;
      var countEl = tab.querySelector('.jdgm-subtab__count');
      var label = SUBTAB_LABELS[tabName];
      var target = label + LEADING_TEXT;
      var leadingText = countEl ? tab.firstChild : null;
      if (countEl) {
        if (!leadingText || leadingText.nodeType !== Node.TEXT_NODE || leadingText.textContent !== target) {
          if (leadingText && leadingText.nodeType === Node.TEXT_NODE) {
            leadingText.textContent = target;
          } else {
            tab.insertBefore(document.createTextNode(target), tab.firstChild);
          }
        }
      } else if (tab.textContent.trim() !== label) {
        tab.textContent = label;
      }
    });
  }

  function buildSliderNav(ariaLabel) {
    // A small prev/next control row used on mobile to move a horizontally
    // scrolling review row by tap, in addition to swipe. It never overlaps
    // the cards themselves (it sits in normal flow, above the scroll row),
    // which avoids the overlap/contrast issue found in the header's arrow.
    var nav = document.createElement('div');
    nav.className = 'leo-slider-nav';
    nav.setAttribute('role', 'group');
    if (ariaLabel) nav.setAttribute('aria-label', ariaLabel);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'leo-slider-nav__btn leo-slider-nav__btn--prev';
    prev.setAttribute('aria-label', '前へ');
    prev.textContent = '‹';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'leo-slider-nav__btn leo-slider-nav__btn--next';
    next.setAttribute('aria-label', '次へ');
    next.textContent = '›';

    nav.appendChild(prev);
    nav.appendChild(next);
    return { nav: nav, prev: prev, next: next };
  }

  function setupSlider(scrollEl, navRefs) {
    // Wires the prev/next buttons to scroll the given row by one card's
    // width. Only ever calls scrollBy() on the existing scroll container;
    // it doesn't touch which cards exist or their content. Guarded by a
    // dataset flag so re-running init() never double-binds the buttons.
    if (!scrollEl || !navRefs || scrollEl.dataset.leoSliderBound) return;
    scrollEl.dataset.leoSliderBound = '1';
    var prev = navRefs.prev;
    var next = navRefs.next;

    function step() {
      var card = scrollEl.querySelector('.jdgm-rev');
      if (!card) return scrollEl.clientWidth;
      var gapStr = window.getComputedStyle(scrollEl).columnGap || window.getComputedStyle(scrollEl).gap || '0';
      var gap = parseFloat(gapStr) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      prev.disabled = scrollEl.scrollLeft <= 2;
      next.disabled = maxScroll <= 2 || scrollEl.scrollLeft >= maxScroll - 2;
    }

    prev.addEventListener('click', function () {
      scrollEl.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scrollEl.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scrollEl.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function buildPickupSection(body, cards) {
    if (document.querySelector('.leo-pickup-grid')) return;
    var picks = cards.filter(function (c) {
      var ratingEl = c.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? parseInt(ratingEl.getAttribute('data-score') || '0', 10) : 0;
      var bodyEl = c.querySelector('.jdgm-rev__body');
      var len = bodyEl ? bodyEl.textContent.trim().length : 0;
      return score >= 5 && len >= 40;
    }).slice(0, 3);
    if (picks.length < 3) {
      picks = cards.slice(0, Math.min(3, cards.length));
    }
    if (!picks.length) return;

    var section = document.createElement('div');
    section.className = 'leo-pickup-section';
    var heading = document.createElement('h2');
    heading.className = 'leo-reviews-section-heading';
    heading.textContent = 'PICK UP REVIEWS';
    var navRefs = buildSliderNav('PICK UP REVIEWSを移動');
    var grid = document.createElement('div');
    grid.className = 'leo-pickup-grid';
    section.appendChild(heading);
    section.appendChild(navRefs.nav);
    section.appendChild(grid);
    body.parentNode.insertBefore(section, body);

    picks.forEach(function (c) {
      c.classList.add('leo-rev--pickup');
      grid.appendChild(c); // moves the existing live node, does not clone it
    });

    setupSlider(grid, navRefs);
  }

  function buildAllReviewsHeader(body) {
    if (document.querySelector('.leo-review-filters')) {
      return document.querySelector('.leo-review-filters');
    }
    var wrap = document.createElement('div');
    wrap.className = 'leo-all-reviews-section';
    var heading = document.createElement('h2');
    heading.className = 'leo-reviews-section-heading';
    heading.textContent = 'ALL REVIEWS';
    var navRefs = buildSliderNav('ALL REVIEWSを移動');
    var filters = document.createElement('div');
    filters.className = 'leo-review-filters';
    wrap.appendChild(heading);
    wrap.appendChild(navRefs.nav);
    wrap.appendChild(filters);
    body.parentNode.insertBefore(wrap, body);
    setupSlider(body, navRefs);
    return filters;
  }

  function applyPagination(body, moreBtn) {
    var visible = reviewCardsOf(body).filter(function (c) {
      return c.style.display !== 'none';
    });
    var limit = Math.max(shownCount, isMobile() ? PAGE_SIZE_MOBILE : PAGE_SIZE_DESKTOP);
    visible.forEach(function (c, i) {
      c.classList.toggle('leo-rev--hidden-page', i >= limit);
    });
    if (moreBtn) {
      var wrap = moreBtn.closest('.leo-reviews-more-wrap') || moreBtn.parentElement;
      if (wrap) wrap.style.display = visible.length > limit ? '' : 'none';
    }
  }

  function setupFilters(filters, body, moreBtn) {
    if (filters.dataset.leoBuilt) return;
    filters.dataset.leoBuilt = '1';
    FILTER_CATEGORIES.forEach(function (cat, i) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'leo-filter-chip' + (i === 0 ? ' is-active' : '');
      chip.textContent = cat;
      chip.dataset.category = cat;
      chip.addEventListener('click', function () {
        Array.prototype.forEach.call(filters.querySelectorAll('.leo-filter-chip'), function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        reviewCardsOf(body).forEach(function (c) {
          var show = cat === 'すべて' || c.dataset.leoCategory === cat;
          c.style.display = show ? '' : 'none';
        });
        body.scrollLeft = 0;
        shownCount = isMobile() ? PAGE_SIZE_MOBILE : PAGE_SIZE_DESKTOP;
        applyPagination(body, moreBtn);
      });
      filters.appendChild(chip);
    });
  }

  var cachedBody = null;
  var cachedMoreBtn = null;

  function applySubtabVisibility() {
    // Judge.me's "製品/商品レビュー" vs "ショップレビュー" sub-tabs only
    // show/hide Judge.me's own two body containers
    // (.jdgm-all-reviews__body / .jdgm-shop-reviews__body). Our PICK UP
    // REVIEWS grid and ALL REVIEWS header/filters live in separate
    // sibling elements Judge.me doesn't know about, so without this they
    // stay visible no matter which sub-tab is active — which is why
    // switching tabs looked like it did nothing. This just shows/hides
    // those two custom sections to match the active sub-tab; it never
    // touches Judge.me's own tab-switching or fetch logic.
    var productTab = document.querySelector('.jdgm-subtab__name[data-tabname="product-reviews"]');
    var isProductActive = !productTab || productTab.classList.contains('jdgm--active');
    ['.leo-pickup-section', '.leo-all-reviews-section'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = isProductActive ? '' : 'none';
    });
    if (isProductActive) {
      if (cachedBody) applyPagination(cachedBody, cachedMoreBtn);
    } else {
      var wrap = document.querySelector('.leo-reviews-more-wrap');
      if (wrap) wrap.style.display = 'none';
    }
  }

  function setupSubtabVisibility() {
    var subtab = document.querySelector('.jdgm-subtab');
    if (!subtab || subtab.dataset.leoVisBound) return;
    subtab.dataset.leoVisBound = '1';
    subtab.addEventListener('click', function () {
      // Defer a tick so this reads the tab's jdgm--active state *after*
      // Judge.me's own click handler has updated it.
      setTimeout(applySubtabVisibility, 0);
    });
    applySubtabVisibility();
  }

  function init() {
    // Runs regardless of whether the review list itself is ready yet, since
    // the write-review form (and its data-usage disclaimer paragraph) can
    // appear independently of the reviews body below.
    relabelDataPolicyText();
    relabelReviewerNameField();

    var body = document.querySelector('.jdgm-all-reviews__body');
    if (!body) return;
    var cards = reviewCardsOf(body);
    if (!cards.length) return;

    // categorize()/addTruncation()/addReplyClamp() are re-run on every
    // init() pass (DOMContentLoaded, load, timeouts, and DOM mutations)
    // rather than gated behind a single "already initialised" flag. The
    // Judge.me v2025 widget can still be filling in each review's real
    // product link when the first pass runs, which previously locked in
    // an incorrect "その他" category for every card. Re-categorizing on
    // every pass is cheap and self-heals once the real product link is
    // present; addTruncation()/addReplyClamp() already guard themselves
    // per-element (dataset.leoClamp / dataset.leoReplyClamp) so re-running
    // them is a no-op once a card has been processed.
    cards.forEach(function (card) {
      card.dataset.leoCategory = categorize(card);
      addTruncation(card);
      addReplyClamp(card);
    });

    relabelWriteLink();
    relabelSubtabs();
    buildPickupSection(body, cards);
    var filters = buildAllReviewsHeader(body);
    body.classList.add('leo-all-reviews__body--grid');

    var moreBtn = document.querySelector('.leo-reviews-more-btn');
    cachedBody = body;
    cachedMoreBtn = moreBtn;
    setupFilters(filters, body, moreBtn);
    applyPagination(body, moreBtn);
    setupSubtabVisibility();

    if (moreBtn && !moreBtn.dataset.leoBound) {
      moreBtn.dataset.leoBound = '1';
      moreBtn.addEventListener('click', function () {
        shownCount += isMobile() ? PAGE_SIZE_MOBILE : PAGE_SIZE_DESKTOP;
        applyPagination(body, moreBtn);
      });
    }

    if (!body.dataset.leoResizeBound) {
      body.dataset.leoResizeBound = '1';
      window.addEventListener('resize', function () {
        applyPagination(body, moreBtn);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  setTimeout(init, 1200);
  setTimeout(init, 2500);
  setTimeout(init, 4200);

  document.addEventListener('DOMContentLoaded', function () {
    var target = document.querySelector('[data-widget="all-reviews-v2025"]') || document.body;
    var mo = new MutationObserver(function () {
      init();
    });
    mo.observe(target, { childList: true, subtree: true });
  });
})();
